/**
 * Determines if the member/coverage card should be shown to the user
 * Example: Mark Cuban Cost Plus Drugs with cash pricing doesn't require showing the SmartPRICE card
 */
export const shouldShowMemberCard = (
    pharmacyName: string,
    isInsuranceOffer: boolean
): boolean => {
    const isCostPlus = pharmacyName.toUpperCase().includes('COST PLUS');
    const isCostPlusCashPrice = isCostPlus && !isInsuranceOffer;
    return !isCostPlusCashPrice;
};
